import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import EvaluationTypeForm from "./EvaluationTypeForm";

export interface State {}

export interface CreateEvaluationTypeFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
}

class CreateEvaluationTypeForm extends React.Component<
  CreateEvaluationTypeFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newData = values;
        }
      });
      return newData;
    });
  }

  render() {
    const { translate } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <EvaluationTypeForm
        translate={translate}
        getFieldDecorator={getFieldDecorator}
      />
    );
  }
}

export default CreateEvaluationTypeForm;
